import { downloadFile, format, mapPaginationParamsToServer } from "@/shared";

import { mapRentFiltersToServer } from "./mappers/mapRentFiltersToServer";

export const exportRents = async (paginationParams, filters) => {
    const fileName = `exported_rents_${format(new Date(), "dd_MM_yyyy-HH_mm")}`;

    await downloadFile("/rent/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapRentFiltersToServer(filters),
    });
};
